// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner":"Spinner_lds-spinner__FKsNw","small":"Spinner_small__UvUlI"};